import SvgIcon from "@material-ui/core/SvgIcon";
import React from "react";

const RemittanceRunnerCheckbox: React.FC = () => (
  <SvgIcon>
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    <path fill="none" className="innerBox" d="M19 5v14H5V5h14" />
  </SvgIcon>
);

export default RemittanceRunnerCheckbox;
